const prefix1 = 'securityIDTypes/';
const prefix2 = 'securityIDs/';
// '^' + prefix1 + '[a-zA-Z]+/' + prefix2
const publicSecurityIDRegex = new RegExp('^securityIDTypes/[a-zA-Z]+/securityIDs/');
export const publicSecurityIDOptions = [
    { label: 'ISIN', value: 'isin' },
    { label: 'SEDOL', value: 'sedol' },
    { label: 'CUSIP', value: 'cusip' },
    { label: 'CIN', value: 'cin' },
    { label: 'REFINITIVTICKER', value: 'refinitivticker' },
    { label: 'CASH', value: 'cash' },
];
export const publicSecurityIDTypes = publicSecurityIDOptions.map(({ value }) => value);
export const isPublicSecurityID = (name) => {
    return publicSecurityIDRegex.test(name);
};
export const IDToName = ({ securityIDType, securityID }) => {
    return prefix1 + securityIDType + '/' + prefix2 + securityID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 4 || !name.startsWith(prefix1) || !name.includes(prefix2)) {
        throw new Error(`bad public security ID name: ${name}`);
    }
    return { securityIDType: parts[1], securityID: parts[3] };
};
export const IDToLabel = ({ securityIDType, securityID }) => {
    return `${securityIDType}: ${securityID}`;
};
export function fromISIN(isin) {
    return IDToName({ securityIDType: 'isin', securityID: isin });
}
export function isISINInPublicSecurityIDName(publicSecurityIDName, ISIN) {
    const { securityID, securityIDType } = nameToID(publicSecurityIDName);
    return securityIDType === 'isin' && securityID === ISIN;
}
export function isISIN(publicSecurityIDName) {
    const id = nameToID(publicSecurityIDName);
    return id.securityIDType === 'isin';
}
